import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { AgentsComponent } from './agents.component';
import { AgentsRouter } from './agents.router';

/** @constant {angular.module} */
const agentsModule = angular
  .module('ec.opsCenter.ops-support.agents', [])
  .config(AgentsRouter)
  .directive('appAgents', downgradeComponent({ component: AgentsComponent }) as angular.IDirectiveFactory).name;

export default agentsModule;



// WEBPACK FOOTER //
// ./src/app/agents/agents.module.ajs.ts